/**
 * Shared next/image sizing config.
 *
 * Imported by BOTH `next.config.ts` (to configure the image optimizer) and
 * `ResponsiveImage` (to generate `<source>` / `<link rel="preload">` srcSets that
 * match exactly what next/image emits for the `<img>`). Keeping a single source
 * of truth prevents a silent double-fetch if the device sizes ever change.
 */
export const IMAGE_DEVICE_SIZES: number[] = [320, 480, 828, 1200, 1920]

// Intentionally empty so only `deviceSizes` are used (mirrors next.config.ts).
export const IMAGE_SIZES: number[] = []

/**
 * Every `quality` value passed to a next/image `<Image>` (directly or via
 * BaseImage) must be listed here, otherwise Next.js 16 logs an
 * "unconfigured qualities" warning. Currently in use:
 * - 75: next/image default (most images)
 * - 80: ResponsiveImage (IMAGE_QUALITY) and other media
 * - 100: footer logo
 */
export const IMAGE_QUALITIES: number[] = [75, 80, 100]
